import React from "react";
import GameSessions from "./GameSessions";
import PlayerSessions from "../_sharedSections/PlayerSessions";

export default function Sessions() {
  return (
    <div>
      <GameSessions />
      <PlayerSessions />
    </div>
  );
}
